import React from "react";
import { AxiosResponse } from "axios";
import {
	ReportComboContext,
	ReportComboContextProps,
	ReportComboContextRequests,
	ReportComboService,
} from "go-report-combo/User/services/context";
import { ReportResponseReportComboApi } from "go-report-combo/User/services/types";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { reportParamsConverter } from "go-report/reports/services/report-service";
import { OrganizationReportComboComponent } from "../components/OrganizationReportComboComponent";
import { UserReportsComboCreatePage } from "./New";
import { UserReportsComboSegmentsPage } from "./segments";

interface Props extends RouteComponentProps, ReportComboContextRequests {
	getReportsCustom: (params?: Record<string, any>, options?: Record<string, any>) => Promise<AxiosResponse>;
	user: Record<string, any>;
	segmentCRUDRedirectPath: string;
	billOrderItemRedirect?: string;
	billOrdersRedirect?: string;
}

export const ReportsComboPage = (props: Props) => {
	const { t } = useTranslation();
	const { getReportsCustom, getTemplates, user, segmentCRUDRedirectPath, billOrderItemRedirect, billOrdersRedirect } =
		props;

	const get = async (resource: string, dataId: string, dataColumnId: string, params: Record<string, string>) => {
		switch (resource) {
			case "BILL": {
				const newParams = JSON.parse(JSON.stringify(params));
				const res = (await getReportsCustom(reportParamsConverter(newParams))) as any;
				return {
					id: dataId,
					column_id: dataColumnId,
					data: res.data.reports[0],
				} as ReportResponseReportComboApi;
			}
		}
	};

	const getPath = (resource: string, filter: string) => {
		switch (resource) {
			case "BILL": {
				if (filter.includes("order_item") && billOrderItemRedirect) {
					return billOrderItemRedirect;
				}
				if (billOrdersRedirect) return billOrdersRedirect;
				break;
			}
			default:
				return undefined;
		}
	};

	const getFilterVariableComponent = (
		variableId: string,
		updateFilters: (value: Record<string, string>) => void,
		filter?: Record<string, string>
	) => {
		const filterType = variableId.split("__")[1];
		switch (filterType) {
			case "ORGANIZATION": {
				return (
					<>
						<OrganizationReportComboComponent
							name={variableId}
							filter={filter}
							onChange={(value) => updateFilters(value)}
							user={user}
						/>
						<hr />
					</>
				);
				break;
			}
			default:
				return undefined;
		}
	};

	return (
		<ReportComboContext.Provider
			value={
				new ReportComboService(
					{
						get,
						getPath,
						getFilterVariableComponent,
						getTemplates,
					} as ReportComboContextProps,
					t,
					segmentCRUDRedirectPath
				)
			}
		>
			<div className={"page-container"}>
				<div className={"content"}>
					<Switch>
						<Route exact path={`${props.match.url}/create`} component={UserReportsComboCreatePage} />
						<Route path={`${props.match.url}/`} component={UserReportsComboSegmentsPage} />
					</Switch>
				</div>
			</div>
		</ReportComboContext.Provider>
	);
};
